import { parseHtmlString } from 'ingestion/nodeCreationHelpers'
import { ISimplifiedNode } from '../../../../../components/ingestion/IngestedTree'
import { prepareQuestionsMultiPart } from './questions'
import { IMActivity } from '../../../types'
import { IM360Parser } from '../../IM360Parser'

export function parseMultiQuestion(
  {
    statement,
    studentResponse,
  }: {
    statement?: string
    studentResponse?: string
  },
  activity?: IMActivity,
) {
  if (!statement) return
  const asHtml = parseHtmlString(statement)
  const questionsList = getQuestionsList(asHtml)
  const answers = getAnswersList(studentResponse)
  if (!questionsList || questionsList.length !== answers.length) return

  const questionNodes: ISimplifiedNode[] = []
  if (asHtml.body.innerHTML) {
    questionNodes.push(
      IM360Parser.getInstance().createNoteNode({
        title: 'Student Task Statement',
        value: asHtml.body.innerHTML,
        studentFacing: true,
      }),
    )
  }
  return questionsList.reduce<ISimplifiedNode[]>((acc, statement, index) => {
    return [
      ...acc,
      ...prepareQuestionsMultiPart(
        {
          statement: statement.innerHTML,
          student_response: answers[index],
        },
        activity,
      ),
    ]
  }, questionNodes)
}

export function parseMultiPart({
  statement,
  studentResponse,
}: {
  statement?: string
  studentResponse?: string
}) {
  if (!statement) return
  const asHtml = parseHtmlString(statement)
  const questionsList = getQuestionsList(asHtml)
  const answers = getAnswersList(studentResponse)
  if (!questionsList || questionsList.length !== answers.length) return
  return [
    IM360Parser.getInstance().createMultiPartQuestion(
      asHtml.body.innerHTML,
      getQuestionsNodeData(questionsList, answers),
    ),
  ]
}

function getQuestionsNodeData(questionsList: Element[], answers: string[]) {
  return questionsList.map((qt, index) =>
    IM360Parser.getInstance().createShortAnswer({
      description: qt.innerHTML,
      teacherNote: answers[index],
    }),
  )
}

function getQuestionsList(document: Document) {
  const questionsList =
    document.getElementsByTagName('ol').item(0) ??
    document.getElementsByTagName('ul').item(0)
  if (!questionsList) return
  questionsList.remove()
  return Array.from(questionsList.children).filter(
    (child) => child.tagName.toLowerCase() === 'li',
  )
}

function getAnswersList(studentResponse?: string) {
  if (!studentResponse) return []
  const doc = parseHtmlString(studentResponse)
  const questionsList =
    doc.getElementsByTagName('ol').item(0) ??
    doc.getElementsByTagName('ul').item(0)
  if (!questionsList) return []
  return Array.from(questionsList.children).map((c) => c.innerHTML)
}
